import { render } from "./SystemMessage2.vue?vue&type=template&id=6c7a14e3"
import script from "./SystemMessage2.vue?vue&type=script&lang=js"
export * from "./SystemMessage2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/SystemMessage2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c7a14e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c7a14e3', __exports__)) {
    api.reload('6c7a14e3', __exports__)
  }
  
  module.hot.accept("./SystemMessage2.vue?vue&type=template&id=6c7a14e3", () => {
    api.rerender('6c7a14e3', render)
  })

}


export default __exports__